module.exports = __webpack_public_path__ + "img/ed-c.842a50af.jpg";